<script lang="ts">
  import { submitData } from "./data";
  import { onMount, onDestroy } from 'svelte';
  import Progress from "./Progress.svelte";
  export let comps: any[];
  import { fly } from "svelte/transition";
  let index = 0;
  let currentComponent;

  const handleNext = () => {
    let canContinue = true;
    if (!currentComponent.tryNext) {
      console.warn(`Component "${currentComponent.constructor.name}" should export tryNext function`);
    } else {
      canContinue = currentComponent.tryNext();
    }
    if (canContinue) {
      index++;
      history.pushState({ index }, index.toString());
    }
  }
  const handleBack = () => {
      index--;
      history.pushState({ index }, index.toString());
  }
  const popstateHandler = (e) => {
      try {
          index = e.state.index || 0;
      } catch (err) {
          console.log(e, err);
      }
      e.preventDefault();
  }
  onMount(() => {
    window.addEventListener('popstate', popstateHandler);
  });
  onDestroy(() => {
    window.removeEventListener('popstate', popstateHandler);
  })

</script>

<style>
  div.buttons {
    margin-top: 1em;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  div.buttons>button {
    margin-left: 1em;
  }
</style>

<Progress value={index} total={comps.length} />

<!-- https://github.com/sveltejs/svelte/issues/1469 -->
{#each [index] as k (k)}
  <div key={index} in:fly={{ duration: 1500 }}>
    <svelte:component
      bind:this={currentComponent}
      this={comps[index].component}
      {...comps[index].props || {}} />
  </div>
{/each}

<div class="buttons">
  {#if index === 0}
    <button disabled>Vorige</button>
  {:else}
    <button on:click={handleBack}>Vorige</button>
  {/if}
  {#if index < comps.length - 1}
    <button on:click={handleNext}>Volgende</button>
  {:else}
    <button on:click={() => submitData()}>Verzenden</button>
  {/if}
</div>
